import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizard.Schedule = {
  displayName: 'Schedule',

  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    onStepProgression()
  },

  component: React.createClass({
    getInitialState: function() {
      const job = Job.Data;

      return {
        schedule:     job.schedule || 'flexible',
        scheduleDate: job.scheduleDate
      }
    },

    componentDidMount: function() {
      $('#schedule-radio-group').radioButtonGroup({activeRowClass: 'active'})

      $('#schedule-date').datepicker({
        container: '#job-modal',
        format: 'dd/mm/yyyy',
        disableTouchKeyboard: true,
        todayHighlight: true,
        orientation: 'top left',
        startDate: '+1d'
      }).on('changeDate', function(event){
        $(this).datepicker('hide')
        JobWizard.Validator.$form.data('bootstrapValidator').revalidateField("scheduleDate") //revalidating removes error message
        Job.Actions.updateScheduleDate(event.currentTarget.value)
      })

      this.setupValidation()

      if (Job.Data.resetEmailAddressSlide === true) {
        JobWizard.Emitter.emit('job:wizard:advanceToStep', JobWizard.EmailAddress)
      }
    },

    setupValidation: function() {
      const validator = JobWizard.Validator;

      $(function() {
        validator.addField(
          'schedule',
          {
            validators: {
              notEmpty: {
                message: 'Please select a schedule for when you want the job done'
              }
            }
          }
        )
        validator.addField(
          'scheduleDate',
          {
            validators: {
              notEmpty: {
                message: 'Please select a date for when you want the job done'
              }
            }
          }
        )
        JobWizard.Validator.$form.on('error.field.bv', function(e, data) {
          data.element
            .data('bv.messages')
            .find('.help-block[data-bv-for="' + data.field + '"]').show();
        })
      })
    },

    handleClick: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
      Job.Actions.updateSchedule($selectedItem.value)
      hideScheduleDatePanel()

      function hideScheduleDatePanel() {
        $('#schedule-panel').addClass('fade hidden')
      }
    },

    handleDateClick: function(e) {
      const actions = Job.Actions
      actions.updateSchedule("on_a_particular_date")
      actions.updateScheduleDate($('#schedule-date').val())
      $('#schedule-panel').removeClass('fade hidden')
      JobWizard.scrollTo('#schedule-panel')
    },

    handleScheduleRadioClick: function() {
      JobWizard.Validator.$form.data('bootstrapValidator').revalidateField("schedule") //revalidating removes error message
    },

    render: function() {
      const radioButtonVisible = "col-xs-2 col-sm-2 circle"
      let radioButtonHidden = `${radioButtonVisible} hidden`

      return (
        <div>
          <div className="form-group" onClick={this.handleScheduleRadioClick}>
            <h3 className="mb15 mt10">When do you need the job done?</h3>
            <div className="radio-button-box minor-bold" id="schedule-radio-group">
              <div className={"radio flexible " + ((this.state.schedule === "flexible") ? "active" : "")} onClick={this.handleClick}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">I’m flexible</div>
                  <div className={(this.state.schedule === "flexible") ? radioButtonVisible : radioButtonHidden}>
                    <i className="ficon-circle-x pull-right" />
                  </div>
                  <input type="radio" defaultChecked={(this.state.schedule === "flexible") ? 'checked' : ''} id="flexible" name="schedule" value="flexible" className="form-control invisible"/>
                </div>
              </div>
              <div className={"radio next-couple-of-weeks " + ((this.state.schedule === "next_couple_of_weeks") ? "active" : "")} onClick={this.handleClick}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">In the next few weeks</div>
                  <div className={(this.state.schedule === "next_couple_of_weeks") ? radioButtonVisible : radioButtonHidden}>
                    <i className="ficon-circle-x pull-right" />
                  </div>
                  <input type="radio"  defaultChecked={(this.state.schedule === "next_couple_of_weeks") ? 'checked' : ''} id="next_couple_of_weeks" name="schedule" value="next_couple_of_weeks" className="form-control invisible"/>
                </div>
              </div>
              <div className={"radio asap-urgent " + ((this.state.schedule === "asap_urgent") ? "active" : "")} onClick={this.handleClick}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10">Urgently</div>
                  <div className={(this.state.schedule === "asap_urgent") ? radioButtonVisible : radioButtonHidden}>
                    <i className="ficon-circle-x pull-right"/>
                  </div>
                  <input type="radio" defaultChecked={(this.state.schedule === "asap_urgent") ? 'checked' : ''} id="asap_urgent" name="schedule" value="asap_urgent" className="form-control invisible"/>
                </div>
              </div>
              <div className={`radio on-a-particular-date ${((this.state.schedule === 'on_a_particular_date') ? 'active' : '')}`} href="#schedule-panel" role="tab" data-toggle="tab" onClick={this.handleDateClick} >
                <div className="row">
                  <div className='col-xs-10 col-sm-10'>On a Particular Date</div>
                  <div className={(this.state.schedule === 'on_a_particular_date') ? radioButtonVisible : radioButtonHidden}>
                    <i className='icon-circle-x pull-right' />
                  </div>
                  <input type="radio" defaultChecked={(this.state.schedule === 'on_a_particular_date') ? 'checked' : ''} name="schedule" value="on_a_particular_date" className="form-control invisible" />
                </div>
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="schedule-panel" className={"tab-pane form-group " +((this.state.schedule === "on_a_particular_date") ? "active" : "")} role="tabpanel" >
              <h3 className="mb15 mt30">Best date for work</h3>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon bg-white"><i className="ficon-calendar"></i></div>
                  <input id="schedule-date" name="scheduleDate" ref="schedule-date" type="textbox" className="form-control" placeholder="What Day?" defaultValue={this.state.scheduleDate} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
